<template>
  <div class="home-page">
    <div v-if="banner.length" class="home-page-banner flex-row-center">
      <banner :data="banner" />
    </div>
    <div v-else class="home-page-banner flex-row-center default-img-cover" />
    <div class="home-page-tools flex-row-center">
      <div class="home-page-tools-body flex-center">
        <div v-for="(item, index) in catelogs" :key="index" class="home-page-tools-body-item flex-column-center cursor" @click="cateTap(item)">
          <img :src="item.img">
          <p class="font-14">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <div v-if="catalogs.length" class="home-page-news">
      <div class="home-page-news-body safe-with flex">
        <div v-if="cateBanner.length != 0" class="home-page-news-body-left flex-shrink">
          <el-carousel height="360px" style="border-radius: 5px;" :interval="6000" @change="bannerChange">
            <el-carousel-item v-for="(item, index) in cateBanner" :key="index">
              <el-image style="width: 100%; height: 100%; cursor: pointer;" :src="item.bannerImage" fit="cover" @click="bannerLink(index)" />
            </el-carousel-item>
          </el-carousel>
          <div class="home-page-news-body-left-info flex-row-center">
            <p class="text-line-1 font-14">
              {{ cateBanner[bannerIndex].bannerTitle }}
            </p>
          </div>
        </div>
        <!-- 新闻 -->
        <div class="home-page-news-body-right">
          <div class="top flex-row-center-between">
            <div class="cate flex-row-center">
              <span v-for="(item, index) in catalogs" :key="index" class="position-relative cursor">
                <p class="font-16" :class="newsIndex == index? 'sel':''" @click="switchNewsCate(index)">{{ item.catalogName }}</p>
                <p v-if="newsIndex == index" class="line position-absolute" />
              </span>
            </div>
            <div class="more flex-row-center cursor" @click="toMoreNew">
              <p class="font-12">更多</p>
              <img src="../../assets/img/icon-home-news-arrow.png">
            </div>
          </div>
          <div class="list">
            <span v-for="(item, index) in catalogs[newsIndex].articlesList" :key="index" class="item flex-row-center-between cursor" @click="toNewDetail(index)">
              <div class="pre flex-1 flex">
                <div class="flex-center">
                  <p class="dot font-12" />
                </div>
                <p class="font-12 text text-line-1">{{ item.title }}</p>
              </div>
              <div class="tail flex-shrink">
                <p class="font-12">[{{ splitDate(item.createTime) }}]</p>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 图书馆开放时间 -->
    <div class="home-page-opentime">
      <div class="home-page-opentime-body safe-with flex">
        <div class="home-page-opentime-body-left flex-shrink">
          <div class="home-page-opentime-body-left-top position-relative">
            <p class="title font-color-fff font-24 font-bold">本馆开放时间</p>
            <div class="time flex-row-center">
              <span class="flex-column-center">
                <p class="font-bold font-color-fff font-30">每周三</p>
                <p class="font-12 font-color-fff">法定节假日除外</p>
              </span>
              <img src="../../assets/img/icon-home-opentime-arrow.png" style="opacity: 0;">
              <span class="flex-column-center">
                <p class="font-bold font-color-fff font-30">14：30</p>
                <p class="font-12 font-color-fff">开馆时间</p>
              </span>
              <img src="../../assets/img/icon-home-opentime-arrow.png" style="margin-top: -14px;">
              <span class="flex-column-center">
                <p class="font-bold font-color-fff font-30">17：00</p>
                <p class="font-12 font-color-fff">闭馆时间</p>
              </span>
            </div>
            <p class="font-color-fff font-14 text-align-center tip">本馆免费开放（持有效证件参观）  咨询电话：0312-5972155</p>
          </div>
          <div class="home-page-opentime-body-left-bottom flex">
            <span class="flex-1 flex-center cursor" @click="toWeb(0)">
              <img src="../../assets/img/icon-home-opentime-b1.png">
              <p class="font-color-fff font-14">参观预约</p>
            </span>
            <span class="flex-1 flex-center cursor" @click="toWeb(1)">
              <img src="../../assets/img/icon-home-opentime-b2.png">
              <p class="font-color-fff font-14">参观须知</p>
            </span>
            <span class="flex-1 flex-center cursor" @click="toWeb(2)">
              <img src="../../assets/img/icon-home-opentime-b3.png">
              <p class="font-color-fff font-14">服务指南</p>
            </span>
          </div>
        </div>
        <div class="home-page-opentime-body-right flex-1">
          <div class="home-page-opentime-body-right-body cursor position-relative flex-center" @click="toPreview">
            <div class="position-absolute flex-center mask-layer cursor">
              <img class="cursor" src="../../assets/img/icon-home-720.png">
            </div>
            <iframe class="match-height match-width" style="z-index: -1;" src="https://h5.cdn.bjadks.com/website/lvzhengcaovr/index.html" frameborder="no" />
          </div>
        </div>
      </div>
    </div>

    <!-- 数字藏品 -->
    <div class="home-page-coll">
      <div class="home-page-coll-body safe-with flex">
        <div class="home-page-coll-body-left flex-shrink">
          <div class="home-page-coll-body-left-layer flex-column-between">
            <span class="top">
              <p class="tit font-color-fff font-bold font-24">数字藏品</p>
              <p class="info font-14 font-color-fff">吕正操革命精神研学中心设在保定学院图书馆三楼，布展面积400平方米，包括吕正操将军藏书和文物近一万件，其中《资治通鉴》为清同治年间版、《二十四史》为清光绪年间版，还有著名作家梁斌、杨沫、沈从文签名的文学作品等。</p>
            </span>
            <span class="bottom">
              <p class="btn f font-14 font-color-fff cursor" @click="toSourcePage">查看全部 {{ sourceCount }} 件藏品</p>
              <p class="btn s font-14 cursor" @click="toCommemorate">捐赠留言</p>
            </span>
          </div>
        </div>
        <div class="home-page-coll-body-right flex-1 flex">
          <span v-for="(item, index) in collImg" :key="index" class="item" @click="toSource(index)">
            <el-image class="img cursor" :src="item.coverImage" fit="fill" :style="{width: item.description + 'px'}">
              <div slot="error" class="image-slot default-img-cover match-height match-width">
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
          </span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getShowPath } from '@/utils/imgpath'
import banner from '@/components/banner/index.vue'
import api from '@/api/index.js'
export default {
  components: {
    banner
  },
  data() {
    return {
      bannerIndex: 0,
      collImg: [],
      newsIndex: 0,
      catelogs: [{
        name: '走进展馆',
        img: require('../../assets/img/icon-home-cate-1.png'),
        path: '/news?cateId=004005&sourceId=48'
      }, {
        name: '追思缅怀',
        img: require('../../assets/img/icon-home-cate-2.png'),
        path: '/webnews'
      }, {
        name: '光辉事迹',
        img: require('../../assets/img/icon-home-cate-3.png'),
        path: '/history'
      }, {
        name: '网上纪念',
        img: require('../../assets/img/icon-home-cate-4.png'),
        path: '/commemorate?cateId=2'
      }, {
        name: '数字展厅',
        img: require('../../assets/img/icon-home-cate-5.png'),
        path: '/libvr'
      }],
      banner: [],
      catalogs: [],
      cateBanner: [],
      widthAry: [],
      sourceCount: 0,
      webPage: [{
        id: 8,
        catalogId: '004005'
      }, {
        id: 40,
        catalogId: '004005'
      }, {
        id: 41,
        catalogId: '004005'
      }]
    }
  },

  created() {
    this.requestCatalog()
  },
  methods: {
    bannerChange(val) {
      this.bannerIndex = val
    },
    toWeb(val) {
      const { id, catalogId } = this.webPage[val]
      this.$router.push({
        path: '/news',
        query: {
          sourceId: id,
          cateId: catalogId
        }
      })
    },
    toPreview() {
      this.$router.push({
        path: '/libvr'
      })
    },
    toNewDetail(val) {
      const value = this.catalogs[this.newsIndex].articlesList
      this.$router.push({
        path: '/news',
        query: {
          cateId: value[val].catalogId,
          sourceId: value[val].id
        }
      })
    },
    toMoreNew() {
      console.error('====')
      this.$router.push({
        path: '/news',
        query: {
          cateId: this.catalogs[this.newsIndex].catalogId
        }
      })
    },
    toSource(val) {
      console.log(val)
      const value = this.collImg[val]
      this.$router.push({
        path: '/source',
        query: {
          cateId: value.catalogId,
          sourceId: value.id
        }
      })
    },
    toSourcePage() {
      this.$router.push({
        path: '/source'
      })
    },
    toCommemorate() {
      this.$router.push({
        path: '/commemorate',
        query: {
          cateId: 2
        }
      })
    },
    bannerLink(val) {
      const { url } = this.cateBanner[val]
      window.open(url)
    },
    splitDate(str) {
      return str.split(' ')[0]
    },
    switchNewsCate(val) {
      if (this.newsIndex === val) {
        return
      }
      this.newsIndex = val
    },
    async requestCatalog() {
      const res = await this.$store.dispatch('auth/reqCatelog')
      if (res.code === 0) {
        const ary = res.items.catalogArticlesVoList.slice(0, 6)
        ary.forEach(item => {
          item.articlesList = item.articlesList.slice(0, 8)
        })
        console.error(ary)
        this.catalogs = ary
      }
      this.request()
    },
    async request() {
      const r = await api.banner({
        dataType: 1,
        limit: 10,
        page: 1
      })
      if (r.code === 2000) {
        r.items.data.forEach(v => {
          v.bannerImage = this.getImgPath(v.bannerImage)
        })
        this.banner = r.items.data
      }

      const res = await api.banner({
        dataType: 2,
        limit: 10,
        page: 1
      })
      if (res.code === 2000) {
        res.items.data.forEach(v => {
          v.bannerImage = this.getImgPath(v.bannerImage)
        })
        this.cateBanner = res.items.data
      }
      api.sourceList({
        isRecommend: 1,
        page: 1,
        limit: 20
      }).then(res => {
        if (res.code === 2000) {
          res.items.data.forEach(v => {
            if (v.coverImage) {
              v.coverImage = this.getImgPath(v.coverImage)
              const image = new Image()
              image.src = v.coverImage
              image.onload = () => {
                const hg = 150 * (image.width / image.height)
                v.description = hg
              }
            } else {
              v.description = 300
            }
          })
          this.collImg = res.items.data
        }
      })

      const { items } = await api.getResourceCount()
      this.sourceCount = items
    },
    cateTap(val) {
      if (val.path) {
        this.$router.push({
          path: val.path
        })
      } else if (val.url) {
        window.open(val.url)
      }
    },
    getImgPath(src) {
      return getShowPath('img', src)
    },
    toMoreSource() {
      this.$router.push({
        path: '/source'
      })
    },
    toPhoto(val) {
      this.$router.push({
        path: '/photo/info',
        query: {
          id: val.id
        }
      })
    }
  }
}
</script>

<style scoped>
  .home-page {
    margin-top: -60px;
    padding-bottom: 40px;
  }

  .home-page-banner {
    width: 100%;
    background: #fff;
    height: 440px;
  }

  .home-page-tools {
    width: 100%;
    height: 180px;
    margin-top: -40px;
    position: relative;
    z-index: 99;
  }
  .home-page-tools-body {
    width: 1220px;
    margin: 0 auto;
    border-radius: 5px;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }
  .home-page-tools-body-item {
    height: 180px;
    background-color: #FFF;
    flex: 1;
    justify-content: center;
    transition: .3s;
    border-width: 0px 1px 0px 0px;
    border-style: solid;
    border-color: #FAFAFA;
  }
  .home-page-tools-body-item p:last-child {
    margin-top: 20px;
    line-height: 30px;
    color: #1A1A1A;
    border: none;
  }
  .home-page-tools-body-item:hover {
    background: #FAFAFA;
    /* border-width: 0px 1px 0px 0px;
    border-style: solid;
    border-color: #FAFAFA; */
    box-shadow: inset 0px 20px 20px 0px rgba(0, 0, 0, 0.1);
  }

  .home-page-gnyw {
    background-color: #fff;
    padding-top: 20px;
    overflow: hidden;
  }

  .home-page-gnyw-body {
    width: 100%;
  }

  .home-page-gnyw-body-header {
    width: 1240px;
    margin: 0 auto;
    height: 82px;
  }

  .home-page-gnyw-body-header span .mark {
    color: rgba(0,0,0,0.2);
    margin: 0 10px;
  }

  .home-page-gnyw-body-header span:last-child .mark {
    display: none;
  }

  .home-page-gnyw-body-waterfall {
    width: 1280px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 40px;
  }

  .home-page-gnyw-body-waterfall .img-box {
    position: absolute;
    padding: 0 20px;
    cursor: pointer;
    width: 320px;
  }

  .home-page-gnyw-body-waterfall .img-box .img-box-img {
    width: 280px;
    border-radius: 5px;
  }

  .home-page-gnyw-body-waterfall .img-box .layer {
    position: absolute;
    top: 0;
    left: 20px;
    width: 280px;
    bottom: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.2);
    display: none;
  }

  .home-page-gnyw-body-waterfall .img-box .source-type {
    position: absolute;
    right: 25px;
    bottom: 5px;
    height: 20px;
    padding: 5px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
  }

  .home-page-gnyw-body-waterfall .img-box .source-type img {
    margin-right: 2px;
  }

  .home-page-gnyw-body-waterfall .img-box:hover .layer {
    display: flex;
    align-items: flex-end;
    padding: 15px;
  }

  .home-page-gnyw-body-waterfall .img-box:hover .layer p {
    line-height: 20px;
  }

  .home-page-gnyw-body-waterfall .img-box:hover .source-type {
    display: none;
  }

  .mask-layer {
    pointer-events: none;
    position: absolute;
    bottom: 94px;
    left: 0;
    right: 0;
    height: 207px;
    background: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 100%), linear-gradient(180deg, rgba(245,246,250,0.00) 0%, #F5F6FA 100%);
  }

  .home-page-gnyw-body-waterfall-bottom .action-btn {
    background-color: #fff;
  }

  .home-page-gnyw-body-waterfall-bottom .action-btn p {
    background: linear-gradient(180deg, #F7F7F7 0%, rgba(247,247,247,0.00) 100%);
    width: 100%;
    line-height: 40px;
    text-align: center;
    color: #296647;
    border-radius: 5px;
  }

  .home-page-photo {
    background-image: url('../../assets/icon-bg-photo.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding-top: 20px;
  }

  .home-page-photo-body {
    width: 1240px;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, 0);
  }

  .home-page-photo-body-header {
    height: 82px;
  }

  .home-page-photo-body-header span .mark {
    color: rgba(255,255,255,0.2);
    margin: 0 20px;
  }

  .home-page-photo-body-header span:last-child .mark {
    display: none;
  }

  .home-page-photo-body-items {
    flex-wrap: wrap;
  }

  .home-page-photo-body-items .item {
    width: 295px;
    height: 186px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 8px solid #FFFFFF;
    background-position: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
  }

  .home-page-photo-body-items .item:nth-child(4n) {
    margin-right: 0;
  }

  .home-page-digital {
    background-image: url('../../assets/icon-bg-digital.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 20px 0;
  }

  .home-page-digital-body {
    width: 1240px;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, 0);
  }

  .home-page-digital-body-header {
    height: 82px;
  }

  .home-page-digital-body-header span .mark {
    color: rgba(0,0,0,0.2);
    margin: 0 20px;
  }

  .home-page-digital-body-header span:last-child .mark {
    display: none;
  }

  .home-page-digital-body-items {
    flex-wrap: wrap;
  }

  .home-page-digital-body-items .item {
    width: 120px;
    height: 225px;
    margin-right: 40px;
    margin-bottom: 30px;
  }

  .home-page-digital-body-items .item .img {
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.2);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 120px;
    height: 165px;
  }

  .home-page-digital-body-items .item p {
    line-height: 24px;
    margin-top: 10px;
  }

  .home-page-digital-body-items .item:nth-child(8n) {
    margin-right: 0;
  }

  .home-page-news {
    margin-top: 30px;
  }

  .home-page-news-body-left {
    width: 600px;
    height: 360px;
    margin-right: 20px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }

  .home-page-news-body-right {
    flex: 1;
    height: 360px;
  }

  .home-page-news-body-right .top {
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .home-page-news-body-right .top .cate span {
    margin-right: 20px;
  }

  .home-page-news-body-right .top .cate span p:first-child {
    color: #1A1A1A;
    line-height: 50px;
  }

  .home-page-news-body-right .top .cate span p:first-child.sel {
    font-weight: bold;
  }

  .home-page-news-body-right .top .cate span .line {
    width: 100%;
    height: 2px;
    background-color: #B21F12;
    bottom: 0;
  }

  .home-page-news-body-right .top .more p {
    color: #767676;
  }

  .home-page-news-body-right .list {
    overflow: scroll;
    margin-top: 20px;
    height: 290px;
  }

  .home-page-news-body-right .list::-webkit-scrollbar {
    display: none;
  }

  .home-page-news-body-right .list .tail {
    width: 100px;
  }

  .home-page-news-body-right .list .tail p {
    color: #767676;
    text-align: right;
    line-height: 36px;
  }

  .home-page-news-body-right .list .pre {
    margin-right: 20px;
  }

  .home-page-news-body-right .list .pre .dot {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #B21F12;
    line-height: 36px;
  }

  .home-page-news-body-right .list .pre .text {
    line-height: 36px;
    margin-left: 6px;
  }

  .home-page-opentime {
    margin-top: 30px;
  }

  .home-page-opentime-body-left {
    border: 5px;
    width: 600px;
    margin-right: 20px;
  }

  .home-page-opentime-body-left-top {
    padding: 0 20px;
    width: 100%;
    height: 280px;
    background-image: url('../../assets/img/bg-home-opentime.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .home-page-opentime-body-left-bottom {
    height: 80px;
    background: #B21F12;
    border-radius: 0 0 5px 5px;
  }

  .home-page-opentime-body-left-top .title{
    line-height: 70px;
  }

  .home-page-opentime-body-left-top .time{
    height: 140px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
  }

  .home-page-opentime-body-left-top .tip {
    margin-top: 10px;
    line-height: 40px;
  }

  .home-page-opentime-body-left-top .time {
    justify-content: space-around;
    padding: 0 32px;
  }

  .home-page-opentime-body-left-top .time span p:last-child {
    line-height: 30px;
    color: rgba(255,255,255,0.5);
  }

  .home-page-opentime-body-left-bottom span {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%);
    border-width: 0px 1px 0px 0px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.1);
  }

  .home-page-opentime-body-left-bottom span img {
    margin-right: 10px;
  }

  .home-page-opentime-body-left-bottom span:hover {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 100%);
  }

  .home-page-opentime-body-right {
    border-radius: 5px;
  }

  .home-page-opentime-body-right-body {
    height: 100%;
  }

  .home-page-opentime-body-right-body .mask-layer {
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-image: url('../../assets/img/bg-home-vr.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .home-page-coll {
    margin-top: 30px;
  }

  .home-page-coll-body {
    border-radius: 5px;
    overflow: hidden;
  }

  .home-page-coll-body-left {
    width: 240px;
    height: 510px;
    background-image: url('../../assets/img/bg-home-coll.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .home-page-coll-body-left-layer {
    height: 510px;
    background-image: url('../../assets/img/icon-home-coll-layer.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 30px 20px 20px;
  }

  .home-page-coll-body-left-layer .tit {
    line-height: 40px;
  }

  .home-page-coll-body-left-layer .info {
    line-height: 25px;
    margin-top: 10px;
    text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.75);
  }
  .home-page-coll-body-left-layer .bottom .btn {
    width: 200px;
    height: 40px;
    margin-top: 10px;
  }

  .home-page-coll-body-left-layer .bottom .btn.f {
    border: 1px solid #FFFFFF;
    border-radius: 5px;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
  }

  .home-page-coll-body-left-layer .bottom .btn.s {
    background: linear-gradient(180deg, #FFF7CC 0%, #FFDD99 100%);
    border-radius: 5px;
    color: #B21F12;
    line-height: 40px;
    text-align: center;
  }

  .home-page-coll-body-right {
    background-color: #80160D;
    padding: 10px 20px 20px;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow: hidden;
  }

  .home-page-coll-body-right .item {
    margin-right: 10px;
    margin-top: 10px;
  }

  .home-page-coll-body-right .img {
    height: 150px;
    border-radius: 5px;
    background-color: #fff;
  }

  .home-page-news-body-left-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    z-index: 2;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    padding: 0 20px;
  }

  .home-page-news-body-left-info p {
    color: #fff;
    max-width: 400px;
  }

  .default-img-cover {
    background-image: url('../../assets/img/bg-banner-default.png');
    opacity: 0.6;
  }

</style>

<style lang="scss" scoped>
.el-carousel {
  width: 600px;

/deep/ .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 12px 4px;
}
  /deep/ .el-carousel__indicators {
    // 指示器
    left: unset;
    transform: unset;
    right: 3%;
    z-index: 4;
  }
  /deep/ .el-carousel__button {
    // 指示器按钮
    // width: 5px;
    // height: 5px;
    // border: none;
    // border-radius: 50%;
    // background-color: #000;
    width: 5px;
    height: 5px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
  }
  /deep/ .is-active .el-carousel__button {
    // 指示器激活按钮
    width: 5px;
    opacity: 1;
    border-radius: 3px;
    background: #fff;
  }
  /deep/ .el-carousel__arrow--left {
    left: 0px !important;
    border-radius: 0px 4px 4px 0px;
    background-color: #000000;
    opacity: 0.36;
  }
  /deep/ .el-carousel__arrow {
    border: none;
    outline: none;
    padding: 0;
    margin: 0;

    cursor: pointer;
    transition: 0.3s;
    // border-radius: 50%;
    // background-color: rgba(31, 45, 61, 0.11);
    color: #ffffff;
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 14px;
    width: 20px;
    height: 32px;

    // border-radius: 4px 0px 0px 4px;
  }
  /deep/ .el-carousel__arrow:hover {
    background-color: #000000;
    opacity: 0.8;
  }
  /deep/ .el-carousel__arrow--right {
    right: 0px !important;
    border-radius: 4px 0px 0px 4px;
    background-color: #000000;
    opacity: 0.36;
  }
}

</style>
